import { createTheme } from '@mui/material';

import { breakpoints } from 'constants/breakpoints';
import { colors } from 'constants/colors';
import { typography } from 'constants/typography';
import { zIndexes } from 'constants/zIndexes';

export const themes = createTheme({
  colors,
  typography,
  breakpoints,
  zIndex: zIndexes,
});
